import { useState } from 'react';
import { SortOrder } from '../../../redux/reducers/api-types';
import UserUtils, { LOCAL_STORAGE_TABLE_DENSE } from '../../../utils/userUtils';
import { DEFAULT_ROW_NUMBER } from '../../../utils/constants';

export const useTableState = (filters, headers, customRowPerPage) => {
    const { order: urlOrder, page: urlPage, sort: urlSort } = filters;

    const [order, setOrder] = useState<SortOrder>(urlOrder || SortOrder.DESC);
    const [orderBy, setOrderBy] = useState<string>(
        urlSort ||
            headers.find((h) => h.defaultSort)?.idSort ||
            headers.find((h) => h.defaultSort)?.id ||
            headers?.[0]?.idSort ||
            headers?.[0]?.id ||
            'id',
    );
    const [page, setPage] = useState<number>(urlPage ? Number(urlPage - 1) : 0);
    const [dense, setDense] = useState<boolean>(UserUtils.getPref(LOCAL_STORAGE_TABLE_DENSE)?.activated);
    const [rowsPerPage, setRowsPerPage] = useState<number>(customRowPerPage?.[0] ?? DEFAULT_ROW_NUMBER);

    return {
        order,
        setOrder,
        orderBy,
        setOrderBy,
        page,
        setPage,
        dense,
        setDense,
        rowsPerPage,
        setRowsPerPage,
    };
};
